export default __webpack_public_path__ + "static/media/selecta_cube.07f6a9e4.jpg";